module.exports = __webpack_public_path__ + "static/media/YF15_5.951a4ba6.jpg";